import LegalAcceptanceDialog from './LegalAcceptanceDialog'
import StatsNoticeDialog from './StatsNoticeDialog'

/**
 * Les fenêtres liées aux données et aux conditions, montées une fois à la racine :
 * l'acceptation des conditions après connexion (#360), et la notice de suivi, qui
 * ne s'ouvre que depuis « Mes données ».
 */
function ConsentDialogs() {
  return (
    <>
      <LegalAcceptanceDialog />
      <StatsNoticeDialog />
    </>
  )
}

export default ConsentDialogs
